import { FluentButton } from 'owa-fluent-v9-shims';

import { Icon } from '@fluentui/react/lib/Icon';
import * as React from 'react';
import { touchHandler } from 'owa-touch-handler';
import type { HoverActionIconProps, PropertyIconProps } from 'owa-mail-list-item-shared';

export interface IconBarProps {
    hoverActionIcons: HoverActionIconProps[];
    propertyIcons: PropertyIconProps[];
    iconClass: string;
    propertyIconClass: string;
    hoverIconClass: string;
}

export const PropertyIcon = React.memo(function PropertyIcon({
    iconClasses,
    iconName,
    id,
}: PropertyIconProps) {
    return <Icon id={id} className={iconClasses} iconName={iconName} />;
});

export const HoverIcon = React.memo(function HoverIcon(props: HoverActionIconProps) {
    const longPress = props.onContextMenu
        ? touchHandler({
              onLongPress: props.onContextMenu,
          })
        : null;
    const onContextMenuHandler = React.useCallback(
        evt => {
            if (props.onContextMenu) {
                props.onContextMenu(evt);
            }
        },
        [props]
    );
    const onClickHandler = (evt: React.MouseEvent<unknown>) => {
        evt.stopPropagation();
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2722 (58,9): Cannot invoke an object which is possibly 'undefined'.
        // @ts-expect-error
        props.onClickCommand();
    };
    const onDoubleClickHandler = (evt: React.MouseEvent<unknown>) => {
        evt.stopPropagation();
    };
    const onRenderMenuIconHandler = () => null;
    return (
        <FluentButton
            appearance="icon"
            iconProps={{ iconName: props.iconName, className: props.iconClassName }}
            onClick={onClickHandler}
            onDoubleClick={onDoubleClickHandler}
            onRenderMenuIcon={onRenderMenuIconHandler}
            styles={{ root: props.iconClasses }}
            title={props.title}
            aria-label={props.title}
            menuProps={props.menuProps}
            onContextMenu={onContextMenuHandler}
            {...longPress}
        />
    );
});
